const angular = require('angular');


const { productCarouselComponentDefinition } = require('./product-carousel.component');

angular.module('wowApp.shop')
    .component('wowProductCarousel', productCarouselComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/productcarousel/index.js